$(window).bind('load', function(){
	$(document).find('.templateProduct #myCarouselViewed .price .price-new').each(function(){
      decimalSup($(this).text(),$(this),true);
    });
});

$(document).ready(function(){
  var cart_total = 0.0;
  var currentCurrency = $(document).find('.currency__picker > .currency__current').attr('data-code');
  currentCurrency = currentCurrency.toLowerCase();

  //product page
  $(document).find('.variation-availability .stock.in-stock').html($('.selector-wrapper select.single-option-selector option:selected').attr('data-qty'));

  //product page
  $(document).on('change', '.templateProduct .selector-wrapper select.single-option-selector', function(){
    //$(document).find('.templateProduct .vat-price-wrap').addClass('no-visible');
    
    var currentVariantQty = $(this).find('option:selected').attr('data-qty');
    $(document).find('.templateProduct .variation-availability').html(currentVariantQty);

   
  });
  
  
  /*
  *	Show quantity of selected variant
  */
  getVairantQuantity(true);

  /*
  *	Calculate price per piece for variant product
  */
  getVariantPerPieceP(true);
  
  $(document).on('change', '.templateProduct .variations .single-option-selector', function(){
    var thisD = $(this);

  	var selctedVal = thisD.val();
    $('.templateProduct #product-variants > select option').each(function(i,val){

      var tmp = document.getElementById('ProductSelect-product-template').options[i].innerHTML;
      

      if($(this).text() == selctedVal){

        /* Change variant per piece price */
        getVariantPerPieceP(false,$(this).attr('vari-pocet'));

      }
    });

    /* Show vairant quantity */
    getVairantQuantity(true,thisD.find('option:selected').attr('data-qty'));
  });
});

/*
*	Variant Quantity
*/
function getVairantQuantity(pageLoad=false,qtyVal=''){
  var currQty = '';
  if(pageLoad){
    currQty = $('.templateProduct .variations .single-option-selector option:selected').attr('data-qty');
  }else{
    currQty = qtyVal;
  }

  if(currQty.search("Na cestě") != -1){
    currQty = 0;
  }

  /*currQty = currQty.replace(/[^\d]/g,'');*/
  currQty = parseInt(currQty);
  if(currQty > 10){
    $('#variQty').text('> 10 balení');
  }
  if(currQty <= 10){
    $('#variQty').text(currQty + ' balení');
  }
}

/*
*	Calculate price per piece for variant product
*/
function getVariantPerPieceP(pageLoad=false,pocetVal=''){
  if(pageLoad){
    var currPoc = $('.templateProduct #product-variants > select option:selected').attr('vari-pocet');
  }else{
    var currPoc = pocetVal;
  }

  currPoc = parseInt(currPoc);
  var currPrice = $('.templateProduct .price-new > .money').text();
  currPrice = currPrice.replace(/[^\d.-]/g,'');
  currPrice = parseFloat(currPrice);
  var finalPrice = currPrice / currPoc;
  finalPrice = finalPrice.toFixed(2);

  $('.templateProduct #variantPerPiece').text(getcurrencyCode(finalPrice));
}

/*
*	Pre/Suffix for current currency
*/
function getcurrencyCode(amount){
  var currCurrency = $('.currency__picker > .currency__current').attr('data-code');
  if(currCurrency == 'USD'){
    return '$'+amount;
  }

  if(currCurrency == 'CZK'){
    return amount+' Kč';
  }

  if(currCurrency == 'EUR'){
    return '€'+amount;
  }

  if(currCurrency == 'PLN'){
    return amount+' zl';
  }
}
